import { render, staticRenderFns } from "./ORCHField.vue?vue&type=template&id=1cfc5024&"
import script from "./ORCHField.vue?vue&type=script&lang=js&"
export * from "./ORCHField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports